import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUserSummaryInfos } from '../../helpers/registrationHelper';
import Loading from '../Loading';

class User extends Component {

    constructor(props) {
        super(props)
        this.props = props
        this.redirectToProfile = this.redirectToProfile.bind(this)
    }

    componentDidMount() {
        let { user_id } = this.props;
        if (this.props && user_id) {
            getUserSummaryInfos(user_id)
                .then((response) => {
                    if (!response.data.error) {
                        this.setState({ data: response.data })
                    } else {
                        console.log('error occurred')
                    }
                })
        }
    }

    redirectToProfile() {
        if (this.state && this.state.data && this.state.data.user_id != localStorage.getItem('user_id') && this.props.history) {
            this.props.history.push({
                pathname: '/friendProfile',
                state: { user: this.state.data, displayPosts: true }
            })
        } else if (this.props.history) {
            this.props.history.push('/profile')
        }
    }

    render() {
        if (!this.state && !this.props.name) {
            return (<Loading />)
        } else if (this.state && this.state.data) {
            return (
                <div className="user-wrapper">
                    <div className="user" onClick={this.redirectToProfile}>
                        {this.state.data.name}
                    </div>
                    <img alt="profile" src={this.state.data.picture} onClick={this.redirectToProfile} />
                </div>
            )
        } else if (this.props.name) {
            return (
                <div className="user-wrapper">
                    <div className="user" onClick={this.redirectToProfile}>
                        {this.props.name}
                    </div>
                    <img alt="profile" src={this.props.img} onClick={this.redirectToProfile} />
                </div>
            )
        }
    }

}

User.propTypes = {
    name: PropTypes.string,
    img: PropTypes.string,
    history: PropTypes.any,
    user_id: PropTypes.number,
};

export default User;


// WEBPACK FOOTER //
// ./src/components/menu/user.js